<template>
    <div class="container">
        <div class="row mb-3" v-if="authError">
            <div class="col text-center">
                <span class="auth-error error">
                    {{ authError }}
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col text-center">
                <a :href="oauthLink" class="btn btn-light auth-btn">
                    Sign In with Google
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import Preloader from "../common/preloader.vue";

    export default {
        components: {Preloader},
        name: 'AuthComponent',

        data: function(){
            return {
                authKey: "",
                error: null,
                oauthLink: ""
            }
        },

        mounted(){
            this.oauthLink = this.$config.apiUrl + "api/oauth";
        },
        computed: mapState({
            authError: state => state.auth.error
        })

    }
</script>

<style scoped lang="scss">
    span.error{
        display: inline-block;
        color: #fff;
        padding: 10px 15px;
        font-size: 12px;
        background: #d60000;
    }
    .auth-btn{
        padding: 0px 10px;
        line-height: 35px;
        border: 1px solid #bbb;
        background: #D62528;
        color: #fff;
        .separator{
            display: inline-block;
            border-left: 1px solid rgba(187, 187, 187, 0.51);
            height: 50px;
            vertical-align: top;
            margin: 0 5px;
        }
        img{
            height: 50px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/authenticate.component.vue